import type { LiliLinkButtonProps } from './LiliLink.types';
import { LiliLinkSize, LiliLinkType } from './LiliLink.types';
import { getLinkClassName } from './styles';
import { useFontClass } from '../../tokens';

export const LiliLinkButton = (props: LiliLinkButtonProps) => {
  const {
    type = LiliLinkType.DEFAULT,
    size = LiliLinkSize.MEDIUM,
    leftIcon,
    rightIcon,
    title,
    className,
    buttonType = 'button',
    testId,
    id,
    onClick,
    disabled,
  } = props;
  const { fontClass } = useFontClass();

  return (
    <span
      className={getLinkClassName(type, size, fontClass, className, disabled)}
      onClick={disabled ? undefined : onClick}
      id={id}
      data-testid={testId}>
      {leftIcon}
      <button type={buttonType} disabled={disabled}>
        <span>{title}</span>
      </button>
      {rightIcon}
    </span>
  );
};
